// extracted by mini-css-extract-plugin
export default {"page":"ToolPage_page__IQWrc","title":"ToolPage_title__81kaZ","content":"ToolPage_content__9Hnc6"};